import React from 'react';

export function RadioUncheckedIcon(): JSX.Element {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='8' cy='8' fill='white' r='7.5' stroke='var(--color-gray-60)' />
    </svg>
  );
}
